import { useEffect, useState, useCallback, useRef } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faGauge,
    faFileLines,
    faUsers,
    faNewspaper,
    faGear,
    faChartLine,
    faBell,
    faBook,
    faLightbulb,
    faHandshake,
    faChartPie,
    faGlobe,
    faBriefcase,
    faChalkboardTeacher,
    faImage,
    faFolderOpen,
    faCalendar,
    faFilePdf,
    faRobot,
    faSpinner,
    faChartBar,
    faDatabase,
    faRotate,
    faUserPlus,
} from '@fortawesome/free-solid-svg-icons';
import 'react-tabs/style/react-tabs.css';
import './Home.css';
import Modal from 'react-modal';

import PropTypes from 'prop-types';

// Removed NewArticleForm import - NewsManagement handles its own article forms now
import ConsultationForm from '../components/Consultations/ConsultationForm';
import apiHelper from '../utils/apiHelper';
import NewsManagement from '../components/News/NewsManagement';
import PagePropertiesModal from '../components/Pages/PagePropertiesModal';
import GalleryManagement from '../components/Admin/GalleryManagement';
import { toast } from 'react-toastify';
import { repositoryService } from '../services/repositoryService';
import { newsService } from '../services/newsService';
import { eventsService } from '../services/eventsService';
import { workingGroupsService } from '../services/workingGroupsService';
import DaireUsage from '../components/Daire/DaireUsage';
import DaireManage from '../components/Daire/DaireManage';

// Import repository component
import RepositoryBrowser from '../components/Repository/RepositoryBrowser';
import LoadingProgress from '../components/Repository/LoadingProgress';
import SurveysManagement from '../components/Surveys/SurveysManagement';
import WorkingGroupsManagement from '../components/WorkingGroups/WorkingGroupsManagement';
import IndexedDocuments from '../components/Daire/IndexedDocuments';
import WorkInProgress from 'components/Common/WorkInProgress';
import EventsManagement from '../components/Events/EventsManagement';
import TalentsManagement from '../components/Talents/TalentsManagement';
import ContentManagement from '../components/Content/ContentManagement';
import InnovationRadarManagement from '../components/CapabilitiesInnovation/InnovationRadarManagement';
import IndexingManagement from '../components/Indexing/IndexingManagement';
import UserActivity from '../components/Common/UserActivity';
import NotificationManagement from '../components/Notifications/NotificationManagement';
import UserImportPanel from '../components/UserImport/UserImportPanel';

function Home({ currentUser = null, isInitialized = false }) {

    const [selectedPage, setselectedPage] = useState('Home');
    const [searchTerm, setSearchTerm] = useState('');
    const [contentFilter, setContentFilter] = useState('all');

    // Content data
    const [contentSections, setContentSections] = useState([]);
    const [contentItems, setContentItems] = useState([]);
    const [pageSections, setPageSections] = useState({});


    // Users data
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState(['Super Admin', 'Admin', 'Editor', 'Viewer']); // Default roles

    // Members data
    const [members, setMembers] = useState([]);

    // Replace the static import with server data
    const [newsArticles, setNewsArticles] = useState([]);
    const [weeklySections, setWeeklySections] = useState([]);

    // Add separate state for dashboard repository stats (independent from Repository tab)
    const [dashboardRepositoryCount, setDashboardRepositoryCount] = useState(0);
    const [isDashboardRepoLoading, setIsDashboardRepoLoading] = useState(false);

    const [userSearchTerm, setUserSearchTerm] = useState('');
    const [userFilter, setUserFilter] = useState('all');
    const [selectedRole, setSelectedRole] = useState('all');

    const [newsSearchTerm, setNewsSearchTerm] = useState('');
    const [newsFilter, setNewsFilter] = useState('all');
    const [selectedWeeklySection, setSelectedWeeklySection] = useState('all');

    // Add state for selected article and popup visibility
    // Removed selectedArticle and showPopup - NewsManagement handles article editing now

    // Add pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const articlesPerPage = 10;



    // Add state for new article form
    // Removed showNewArticleForm - NewsManagement handles its own article creation now

    // Update the repository state initialization
    const [repositoryItems, setRepositoryItems] = useState([]);

    // Consultations data
    const [consultations, setConsultations] = useState([]);
    const [showConsultationForm, setShowConsultationForm] = useState(false);
    const [selectedConsultation, setSelectedConsultation] = useState(null);

    // Add state for expanded section
    const [expandedSection, setExpandedSection] = useState(null);

    // Add state for page properties
    const [showPageProperties, setShowPageProperties] = useState(false);
    const [selectedPageProperties, setSelectedPageProperties] = useState(null);



    // Add a new state to track which tab is active
    const [activeTab, setActiveTab] = useState(0);

    // Add loading states for each data type
    const [isLoadingRepository, setIsLoadingRepository] = useState(false);
    const [isLoadingNews, setIsLoadingNews] = useState(false);

    // Add these state declarations with the other states
    const [workingGroups, setWorkingGroups] = useState([]);

    // Add a loading progress state
    const [loadingProgress, setLoadingProgress] = useState(0);

    // Add these new states
    const [totalItems, setTotalItems] = useState(0);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    // Add new state for repository years
    const [repositoryYears, setRepositoryYears] = useState([]);

    // Add new state for years loading
    const [isLoadingYears, setIsLoadingYears] = useState(true);

    // Add new state
    const [isLoadingGroups, setIsLoadingGroups] = useState(true);

    // Add this with your other state declarations
    const [selectedRepositoryYear, setSelectedRepositoryYear] = useState(
        new Date().getFullYear().toString()
    );

    // Add this near your other state declarations
    const [isLoadingDocuments, setIsLoadingDocuments] = useState(false);

    // Add with your other state declarations
    const [isRefreshing, setIsRefreshing] = useState(false);



    // Add this near other state declarations
    const [surveys, setSurveys] = useState([]);

    // Add new state for Qdrant documents
    const [qdrantDocuments, setQdrantDocuments] = useState([]);
    const [isLoadingQdrant, setIsLoadingQdrant] = useState(false);

    // Add new state for selectedDaireTab
    const [selectedDaireTab, setSelectedDaireTab] = useState(0);

    // Add new state for indexingReport and showReportModal
    const [indexingReport, setIndexingReport] = useState(null);
    const [showReportModal, setShowReportModal] = useState(false);

    // Add state for survey modal
    const [showSurveyModal, setShowSurveyModal] = useState(false);
    
    // Add state for daire modal
    const [showDaireModal, setShowDaireModal] = useState(false);
    
    // Add state for indexing modal
    const [showIndexingModal, setShowIndexingModal] = useState(false);
    
    // Add state for notification modal
    const [showNotificationModal, setShowNotificationModal] = useState(false);

    // Add real stats counting - NO MORE FAKE DATA! 🔥
    const [eventsCount, setEventsCount] = useState(0);
    const [galleriesCount, setGalleriesCount] = useState(0);
    const [isLoadingStats, setIsLoadingStats] = useState(false);

    // Fetch both news articles and weekly sections
    const fetchNews = async () => {
        try {
            const newsData = await apiHelper.fetchNewsData(true);
            
            setNewsArticles(newsData.newsArticles);
            setWeeklySections(newsData.weeklySections);
        } catch (error) {
            toast.error('Failed to load news data');
        }
    };


    // Helper function to map icon strings to FontAwesome icons
    const getIconComponent = (iconName) => {
        const iconMap = {
            faGlobe,
            faHandshake,
            faLightbulb,
            faBriefcase,
            faChalkboardTeacher,
            faChartPie,
            faUsers,
            faBook
        };
        return iconMap[iconName] || faLightbulb;
    };

    const mappedPageSections = Object.entries(pageSections).reduce((acc, [key, sections]) => {
        acc[key] = sections.map(section => ({
            ...section,
            icon: getIconComponent(section.icon)
        }));
        return acc;
    }, {});

    const filteredUsers = users.filter(user => {
        const matchesSearch =
            user.name.toLowerCase().includes(userSearchTerm.toLowerCase()) ||
            user.email.toLowerCase().includes(userSearchTerm.toLowerCase()) ||
            user.department.toLowerCase().includes(userSearchTerm.toLowerCase());
        const matchesStatus = userFilter === 'all' || user.status.toLowerCase() === userFilter.toLowerCase();
        const matchesRole = selectedRole === 'all' || user.role === selectedRole;
        return matchesSearch && matchesStatus && matchesRole;
    });



    // Reset page when filters change
    useEffect(() => {
        setCurrentPage(1);
    }, [newsSearchTerm, newsFilter, selectedWeeklySection]);

    // Load stats in parallel - each updates as it completes! 🚀
    useEffect(() => {
        const loadStatsInParallel = () => {
            
            // Load Events (should be fastest)
            eventsService.getAllEvents()
                .then(eventsData => {
                    setEventsCount(eventsData.length);
                })
                .catch(error => {
                    console.error('Events error:', error);
                    setEventsCount(0);
                });

            // Load Working Groups
            workingGroupsService.getWorkingGroups()
                .then(groups => {
                    const groupsArray = Array.isArray(groups) ? groups : [];
                    setWorkingGroups(groupsArray);
                })
                .catch(error => {
                    console.error('Working Groups error:', error);
                    setWorkingGroups([]);
                });

            // Load News
            apiHelper.fetchNewsData(true)
                .then(newsData => {
                    setNewsArticles(newsData.newsArticles || []);
                    setWeeklySections(newsData.weeklySections || []);
                })
                .catch(error => {
                    console.error('News error:', error);
                    setNewsArticles([]);
                });

            // Load Repository count for dashboard stats (separate from Repository tab)
            setIsDashboardRepoLoading(true);
            repositoryService.getAllItems(null, null)
                .then(items => {
                    const itemsArray = Array.isArray(items) ? items : [];
                    setDashboardRepositoryCount(itemsArray.length);
                })
                .catch(error => {
                    console.error('Dashboard repository error:', error);
                    setDashboardRepositoryCount(0);
                })
                .finally(() => {
                    setIsDashboardRepoLoading(false);
                });

        };
        
        loadStatsInParallel();
    }, []);


    useEffect(() => {
        const observerOptions = {
            threshold: 0.15,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                }
            });
        }, observerOptions);

        const revealElements = document.querySelectorAll('.reveal');
        revealElements.forEach(element => observer.observe(element));

        return () => {
            revealElements.forEach(element => observer.unobserve(element));
        };
    }, []);


    const filteredContent = contentItems.filter(item => {
        const matchesSearch = item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.content.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesFilter = contentFilter === 'all' || item.status === contentFilter;
        const matchesSection = item.page === selectedPage;
        return matchesSearch && matchesFilter && matchesSection;
    });

    // Removed handleClosePopup - NewsManagement handles article interactions now

    // Removed handleEditArticle - NewsManagement handles article editing now










    // Removed handleNewArticleClose - NewsManagement handles its own forms now

    // Removed handleNewArticleSave - NewsManagement handles article saving now

    // Add repository handlers
    const handleUploadDocument = async (formData) => {
        try {
            setIsLoadingRepository(true);

            await repositoryService.uploadDocument(formData);

            // Refresh only the current year after successful upload
            const currentYearItems = await repositoryService.getAllItems(null, selectedRepositoryYear);
            setRepositoryItems(Array.isArray(currentYearItems) ? currentYearItems : []);

            return true; // Indicate success
        } catch (error) {
            console.error('Upload error in Home:', error);
            throw error; // Let the RepositoryBrowser handle the error
        } finally {
            setIsLoadingRepository(false);
        }
    };

    const handleEditDocument = (document) => {
        // TODO: Implement document edit
        console.log('Edit document:', document);
    };

    const handleDeleteDocument = async (pointId) => {
        if (window.confirm('Are you sure you want to delete this document?')) {
            try {
                await apiHelper.deleteQdrantDocument(pointId, 'Repository');
                await fetchQdrantDocuments(); // Refresh the list
                toast.success('Document deleted successfully');
            } catch (error) {
                console.error('Error deleting document:', error);
                toast.error('Failed to delete document');
            }
        }
    };

    const handleDownloadDocument = (document) => {
        // TODO: Implement document download
        console.log('Download document:', document);
    };

    const handleSubmitConsultation = (formData) => {
        const isEditing = !!formData.id;
        if (isEditing) {
            setConsultations(prev => prev.map(c => c.id === formData.id ? formData : c));
        } else {
            // Generate a new ID for new consultations
            const newId = Math.max(...consultations.map(c => c.id)) + 1;
            setConsultations(prev => [...prev, { ...formData, id: newId }]);
        }
        setShowConsultationForm(false);
    };

    // Add new handler function after other handlers
    const handlePagePropertiesSave = (updatedPage) => {
        // TODO: Implement save functionality
        setSelectedPageProperties(null);
    };

    // Update the formatIrishDate function
    const formatIrishDate = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            if (isNaN(date)) return '';

            return date.toLocaleDateString('en-IE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (error) {
            console.error('Error formatting date:', error);
            return '';
        }
    };




    // Update handleTabSelect to match new tab structure
    const handleTabSelect = async (index) => {

        setActiveTab(index);

        try {
            // Dashboard Tab (index 0) - no additional data loading needed

            // News Tab (index 1)
            if (index === 1 && !newsArticles.length) {
                setIsLoadingNews(true);
                await fetchNews();
            }

            // Events Tab (index 2) - handled by EventsManagement component

            // Working Groups Tab (index 3) - handled by WorkingGroupsManagement component

            // Content Tab (index 4) - placeholder accordions

            // Galleries Tab (index 5) - handled by GalleryManagement component

            // Repository Tab (index 6) - ALWAYS load items when tab is clicked
            if (index === 6) {
                setIsLoadingRepository(true);
                const currentYear = new Date().getFullYear().toString();
                
                // Ensure selectedRepositoryYear is set BEFORE loading
                setSelectedRepositoryYear(currentYear);
                
                // Clear existing items first to ensure we only show selected year
                setRepositoryItems([]);
                
                try {
                    const items = await repositoryService.getAllItems(null, currentYear);
                    const itemsArray = Array.isArray(items) ? items : [];
                    setRepositoryItems(itemsArray);
                    setTotalItems(itemsArray.length);
                } catch (error) {
                    console.error('Repository load error:', error);
                    toast.error('Failed to load repository items');
                    setRepositoryItems([]);
                } finally {
                    setIsLoadingRepository(false);
                }
            }
        } catch (error) {
            console.error('Error loading tab data:', error);
            toast.error('Failed to load data');
            if (index === 6) {
                setRepositoryItems([]);
            }
            if (index === 1) {
                setNewsArticles([]);
            }
        } finally {
            // Only reset loading states for the appropriate tabs
            if (index === 1) {
                setIsLoadingNews(false);
            }
            // Don't reset isLoadingRepository here - it's handled in the Repository block above
        }
    };

    // Add more logging to the refresh handler
    const handleRefreshRepository = async () => {
        setIsLoadingRepository(true);
        setIsLoadingYears(true);

        try {
            await repositoryService.clearCache();
            
            // Get items based on current year selection - but don't load all if no year selected
            const yearFilter = selectedRepositoryYear === 'all' ? null : selectedRepositoryYear;
           

            // Only call getAllItems, don't try to destructure multiple values
            const items = await repositoryService.getAllItems(null, yearFilter);
            setRepositoryItems(Array.isArray(items) ? items : []);
            
           

        } catch (error) {
            console.error('Error refreshing repository:', error);
            toast.error('Failed to refresh repository items');
        } finally {
            setIsLoadingRepository(false);
            setIsLoadingYears(false);
        }
    };

    // Update the handleRepositoryYearChange
    const handleRepositoryYearChange = async (newYear) => {


        if (newYear === selectedRepositoryYear) {

            return;
        }

        setSelectedRepositoryYear(newYear);
        setIsLoadingRepository(true);

        try {
            const items = await repositoryService.getAllItems(null, newYear);


            setRepositoryItems(items);
        } catch (error) {
            console.error('Error fetching repository items:', error);

            toast.error('Failed to load repository items');
        } finally {
            setIsLoadingRepository(false);
        }
    };

    // Repository tab loading is handled entirely in handleTabSelect
    // No useEffect needed - it was causing conflicts

    // Update loadRepositoryDocuments to accept a year parameter
    const loadRepositoryDocuments = async (year) => {
        try {
            setIsLoadingDocuments(true);
            const items = await repositoryService.getAllItems(null, year);
            setRepositoryItems(items || []);
            return items;
        } catch (error) {
            console.error('Error loading documents:', error);
            toast.error('Failed to load documents');
            return [];
        } finally {
            setIsLoadingDocuments(false);
        }
    };

    // Update handleYearChange to properly handle both year changes and uploads
    const handleYearChange = async (yearOrFormData) => {
        try {
            // If it's a FormData object, it's an upload
            if (yearOrFormData instanceof FormData) {

                setIsLoadingDocuments(true);

                // Upload the document
                await repositoryService.uploadDocument(yearOrFormData);

                // Refresh the current year's documents
                await loadRepositoryDocuments(selectedRepositoryYear);

                return true;
            }

            // Otherwise it's a year change

            if (typeof yearOrFormData === 'string') {
                setSelectedRepositoryYear(yearOrFormData);
                await loadRepositoryDocuments(yearOrFormData);
            } else {
                console.error('Invalid year format:', yearOrFormData);
            }
        } catch (error) {
            console.error('Error in handleYearChange:', error);
            toast.error(error.message || 'Operation failed');
            throw error;
        } finally {
            setIsLoadingDocuments(false);
        }
    };

    // Update the handleBrowseClick in NewArticleForm to trigger document loading if needed
    // Removed handleAddArticleClick - NewsManagement handles its own article creation now



    // Add this function to handle section expansion
    const handleSectionExpand = async (sectionTitle) => {
        // Toggle section if clicking the same one
        if (expandedSection === sectionTitle) {
            setExpandedSection(null);
            return;
        }

        setExpandedSection(sectionTitle);

        // Load news data when News section is expanded
        if (sectionTitle === 'News' && newsArticles.length === 0) {
            setIsLoadingNews(true);
            try {
                await fetchNews();
            } catch (error) {
                console.error('Failed to load news:', error);
                toast.error('Failed to load news articles');
            } finally {
                setIsLoadingNews(false);
            }
        }
    };



    const fetchQdrantDocuments = async () => {
        setIsLoadingQdrant(true);
        try {
            const qdrantResponse = await apiHelper.get('api/qdrant/list');
            

            if (qdrantResponse.data?.result?.points) {
                // Group points by their source document
                const groupedDocuments = qdrantResponse.data.result.points.reduce((acc, point) => {
                    const source = point.payload?.source || 'Untitled Document';
                    if (!acc[source]) {
                        acc[source] = {
                            id: point.id, // Use the first chunk's ID as the document ID
                            title: source,
                            type: 'PDF Document',
                            workingGroup: point.payload?.workingGroup || 'No Working Group',
                            chunks: [],
                            totalChunks: 0
                        };
                    }
                    acc[source].chunks.push({
                        text: point.payload?.text || '',
                        chunkIndex: point.payload?.chunkIndex || 0
                    });
                    acc[source].totalChunks = Math.max(acc[source].totalChunks, point.payload?.totalChunks || 1);
                    return acc;
                }, {});

                // Convert grouped documents to array and sort chunks
                const documents = Object.values(groupedDocuments).map(doc => ({
                    ...doc,
                    chunks: doc.chunks.sort((a, b) => a.chunkIndex - b.chunkIndex),
                    summary: doc.chunks[0]?.text?.substring(0, 200) + '...' || 'No summary available'
                }));

                setQdrantDocuments(documents);
            } else {
                setQdrantDocuments([]);
            }
        } catch (error) {
            console.error('Error fetching Qdrant documents:', error);
            toast.error('Failed to fetch indexed documents');
        } finally {
            setIsLoadingQdrant(false);
        }
    };

    const handleDaireTabSelect = (index) => {
        setSelectedDaireTab(index);
    };

    // Fetch all repository items (no year filter)
    const fetchAllRepositoryItems = async () => {
        setIsLoadingRepository(true);
        try {
            const allItems = await repositoryService.getAllItems();
            setRepositoryItems(Array.isArray(allItems) ? allItems : []);
                toast.success(`Fetched all repository documents (${allItems.length})`);
        } catch (error) {
            console.error('Error fetching all repository items:', error);
            toast.error('Failed to fetch all repository items');
        } finally {
            setIsLoadingRepository(false);
        }
    };

    // Add new handler function handleIndexingReport
    const handleIndexingReport = (report) => {
        setIndexingReport(report);
        setShowReportModal(true);
    };

    return (
        <div className='totalPage'>
            <section className="wrapper">
                <div className="container reveal reveal-delay-1 tabs-container">
                    <Tabs selectedIndex={activeTab} onSelect={handleTabSelect}>
                        <TabList>
                            {/* Core Management */}
                            <Tab>
                                <FontAwesomeIcon icon={faGauge} className="tab-icon" /> Dashboard
                            </Tab>
                            <Tab><FontAwesomeIcon icon={faNewspaper} className="tab-icon" /> News</Tab>
                            <Tab><FontAwesomeIcon icon={faCalendar} className="tab-icon" /> Events</Tab>
                            <Tab><FontAwesomeIcon icon={faUsers} className="tab-icon" /> Working Groups</Tab>
                            <Tab><FontAwesomeIcon icon={faBriefcase} className="tab-icon" /> Talent</Tab>
                            {/* <Tab>
                                <FontAwesomeIcon icon={faLightbulb} className="tab-icon" /> Capabilities & Innovation
                            </Tab> */}
                            <Tab><FontAwesomeIcon icon={faFileLines} className="tab-icon" /> Content</Tab>

                            <div className="tab-divider"></div>

                            {/* Media & Storage */}
                            <Tab><FontAwesomeIcon icon={faImage} className="tab-icon" /> Galleries & Media</Tab>
                            <Tab><FontAwesomeIcon icon={faFolderOpen} className="tab-icon" /> Repository</Tab>

                            <div className="tab-divider"></div>

                            {/* User Management */}
                            <Tab><FontAwesomeIcon icon={faUserPlus} className="tab-icon" /> User Import</Tab>
                        </TabList>

                        <TabPanel>
                            <div className='dashboard-container'>
                                <div className="content-header">
                                    <h2>Dashboard Overview</h2>
                                    <p className="text-muted">Welcome to the Members Portal Admin Dashboard</p>
                                </div>

                                <div className="stats-section">
                                    <div className="stats-header">
                                        <h3>Content Statistics</h3>
                                    </div>
                                    <div className="stats-grid">
                                        <div className="stat-card">
                                        <div className="stat-icon">
                                            <FontAwesomeIcon icon={faNewspaper} />
                                        </div>
                                        <div className="stat-details">
                                            <h3>News Articles</h3>
                                            <p className="stat-number">
                                                {newsArticles.length === 0 && !isLoadingNews ? (
                                                    <FontAwesomeIcon icon={faSpinner} spin />
                                                ) : (
                                                    newsArticles.length
                                                )}
                                            </p>
                                            <span className="stat-period">Published articles</span>
                                        </div>
                                    </div>

                                    <div className="stat-card">
                                        <div className="stat-icon">
                                            <FontAwesomeIcon icon={faCalendar} />
                                        </div>
                                        <div className="stat-details">
                                            <h3>Events</h3>
                                            <p className="stat-number">
                                                {eventsCount === 0 ? (
                                                    <FontAwesomeIcon icon={faSpinner} spin />
                                                ) : (
                                                    eventsCount
                                                )}
                                            </p>
                                            <span className="stat-period">Managed events</span>
                                        </div>
                                    </div>

                                    <div className="stat-card">
                                        <div className="stat-icon">
                                            <FontAwesomeIcon icon={faFilePdf} />
                                        </div>
                                        <div className="stat-details">
                                            <h3>Repository</h3>
                                            <p className="stat-number">
                                                {isDashboardRepoLoading ? (
                                                    <FontAwesomeIcon icon={faSpinner} spin />
                                                ) : (
                                                    dashboardRepositoryCount
                                                )}
                                            </p>
                                            <span className="stat-period">Total documents</span>
                                        </div>
                                    </div>

                                    <div className="stat-card">
                                        <div className="stat-icon">
                                            <FontAwesomeIcon icon={faUsers} />
                                        </div>
                                        <div className="stat-details">
                                            <h3>Working Groups</h3>
                                            <p className="stat-number">
                                                {workingGroups.length === 0 ? (
                                                    <FontAwesomeIcon icon={faSpinner} spin />
                                                ) : (
                                                    workingGroups.length
                                                )}
                                            </p>
                                            <span className="stat-period">Active groups</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                                <div className="dashboard-grid">
                                    <div className="dashboard-card">
                                        <h3><FontAwesomeIcon icon={faGear} /> Quick Actions</h3>
                                        <div className="quick-actions">
                                            <button 
                                                className="quick-action-btn"
                                                onClick={() => setActiveTab(1)}
                                            >
                                                <FontAwesomeIcon icon={faNewspaper} />
                                                <span>News</span>
                                            </button>
                                            <button 
                                                className="quick-action-btn"
                                                onClick={() => setActiveTab(2)}
                                            >
                                                <FontAwesomeIcon icon={faCalendar} />
                                                <span>Events</span>
                                            </button>
                                            <button 
                                                className="quick-action-btn"
                                                onClick={() => setActiveTab(3)}
                                            >
                                                <FontAwesomeIcon icon={faUsers} />
                                                <span>Working Groups</span>
                                            </button>
                                            {/* <button 
                                                className="quick-action-btn"
                                                onClick={() => setActiveTab(4)}
                                            >
                                                <FontAwesomeIcon icon={faLightbulb} />
                                                <span>Capabilities & Innovation</span>
                                            </button> */}
                                            <button 
                                                className="quick-action-btn"
                                                onClick={() => setActiveTab(6)}
                                            >
                                                <FontAwesomeIcon icon={faImage} />
                                                <span>Galleries</span>
                                            </button>
                                            <button 
                                                className="quick-action-btn"
                                                onClick={() => setActiveTab(6)}
                                            >
                                                <FontAwesomeIcon icon={faFolderOpen} />
                                                <span>Repository</span>
                                            </button>
                                            <button 
                                                className="quick-action-btn"
                                                onClick={() => setShowDaireModal(true)}
                                            >
                                                <FontAwesomeIcon icon={faRobot} />
                                                <span>Daire AI</span>
                                            </button>
                                                                        <button 
                                className="quick-action-btn"
                                onClick={() => setShowSurveyModal(true)}
                            >
                                <FontAwesomeIcon icon={faChartBar} />
                                <span>Surveys</span>
                            </button>
                            <button 
                                className="quick-action-btn"
                                onClick={() => setShowIndexingModal(true)}
                            >
                                <FontAwesomeIcon icon={faDatabase} />
                                <span>Indexing</span>
                            </button>
                            <button 
                                className="quick-action-btn"
                                onClick={() => setShowNotificationModal(true)}
                            >
                                <FontAwesomeIcon icon={faBell} />
                                <span>Notifications</span>
                            </button>
                        </div>
                    </div>

                    <div className="dashboard-card">
                        {/* <UserActivity isInitialized={isInitialized} /> */}
                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className='news-container'>
                                <div className="content-header">
                                    <h2>News Management</h2>
                                    <p className="text-muted">Manage news articles and weekly sections</p>
                                </div>
                                <NewsManagement
                                    newsArticles={newsArticles}
                                    weeklySections={weeklySections}
                                    repositoryItems={repositoryItems}
                                    workingGroups={Array.isArray(workingGroups) ? workingGroups : []}
                                    onUploadDocument={handleUploadDocument}
                                    currentUser={currentUser}
                                    fetchNews={fetchNews}
                                    isLoading={isLoadingNews}
                                />
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className='events-container'>
                                <div className="content-header">
                                    <h2>Events Management</h2>
                                    <p className="text-muted">Manage events and event content</p>
                                </div>
                                <EventsManagement
                                    currentUser={currentUser}
                                />
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className='working-groups-container'>
                                <div className="content-header">
                                    <h2>Working Groups Management</h2>
                                    <p className="text-muted">Manage working groups and their content</p>
                                </div>
                                <WorkingGroupsManagement
                                    currentUser={currentUser}
                                />
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className='talents-container'>
                                <div className="content-header">
                                    <h2>Talent</h2>
                                    <p className="text-muted">Manage talent page resources</p>
                                </div>
                                <TalentsManagement currentUser={currentUser} />
                            </div>
                        </TabPanel>
                        {/* <TabPanel>
                            <div className='capability-innovation-container'>
                                <div className="content-header">
                                    <h2>Innovation Radar Management</h2>
                                    <p className="text-muted">Manage innovation radar drivers, types, and topics from SharePoint</p>
                                </div>
                                <InnovationRadarManagement currentUser={currentUser} />
                            </div>
                        </TabPanel> */}
                        <TabPanel>
                            <div className='content-container'>
                                <div className="content-header">
                                    <h2>Content Management</h2>
                                    <p className="text-muted">Manage content across different sections of the Members Portal</p>
                                </div>

                                <ContentManagement currentUser={currentUser} />
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <GalleryManagement currentUser={currentUser} />
                        </TabPanel>
                        <TabPanel>
                            <div className='repository-container'>
                                <div className="content-header">
                                    <h2>Repository</h2>
                                    <p className="text-muted">Manage the repository for the Members Portal</p>
                                </div>

                                <div className="repository-stats">
                                    <div className="stat-card">
                                        <div className="stat-icon">
                                            <FontAwesomeIcon icon={faFilePdf} />
                                        </div>
                                        <div className="stat-details">
                                            <h3>Total Documents</h3>
                                            <p className="stat-number">
                                                {isLoadingRepository ? (
                                                    <FontAwesomeIcon icon={faSpinner} spin />
                                                ) : (
                                                    repositoryItems.length
                                                )}
                                            </p>
                                            <span className="stat-period">
                                                {selectedRepositoryYear === 'all' ? 'All years' : `Year ${selectedRepositoryYear}`}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="stat-card">
                                        <div className="stat-icon">
                                            <FontAwesomeIcon icon={faFileLines} />
                                        </div>
                                        <div className="stat-details">
                                            <h3>Document Types</h3>
                                            <p className="stat-number">
                                                {isLoadingRepository ? (
                                                    <FontAwesomeIcon icon={faSpinner} spin />
                                                ) : (
                                                    [...new Set(repositoryItems
                                                        .map(item => item.type || 'Unknown')
                                                        .filter(type => type && type.trim() !== '')
                                                    )].length
                                                )}
                                            </p>
                                            <span className="stat-period">Different types</span>
                                        </div>
                                    </div>

                                    <div className="stat-card">
                                        <div className="stat-icon">
                                            <FontAwesomeIcon icon={faRotate} />
                                        </div>
                                        <div className="stat-details">
                                            <h3>Latest Update</h3>
                                            <p className="stat-number" style={{ fontSize: '12px', lineHeight: '1.2' }}>
                                                {isLoadingRepository ? (
                                                    <FontAwesomeIcon icon={faSpinner} spin />
                                                ) : (
                                                    (() => {
                                                        if (repositoryItems.length === 0) return 'N/A';
                                                        const latestItem = repositoryItems
                                                            .filter(item => item.modified)
                                                            .sort((a, b) => new Date(b.modified) - new Date(a.modified))[0];
                                                        if (!latestItem) return 'N/A';
                                                        const date = new Date(latestItem.modified);
                                                        return date.toLocaleDateString('en-IE', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric'
                                                        });
                                                    })()
                                                )}
                                            </p>
                                            <span className="stat-period">Most recent</span>
                                        </div>
                                    </div>
                                </div>

                                {isLoadingRepository ? (
                                    <div className="repository-loading">
                                        <LoadingProgress
                                            current={loadingProgress}
                                            total={totalItems}
                                            isInitialLoad={isInitialLoad}
                                        />
                                    </div>
                                ) : (
                                    <RepositoryBrowser
                                        items={repositoryItems}
                                        workingGroups={workingGroups}
                                        years={repositoryYears}
                                        selectedYear={selectedRepositoryYear}
                                        onUpload={handleYearChange}
                                        onEdit={handleEditDocument}
                                        onDelete={handleDeleteDocument}
                                        onDownload={handleDownloadDocument}
                                        onRefresh={handleRefreshRepository}
                                        onYearChange={handleRepositoryYearChange}
                                        onFetchAll={fetchAllRepositoryItems}
                                        isLoading={isLoadingRepository}
                                        isLoadingYears={isLoadingYears}
                                        isLoadingGroups={isLoadingGroups}
                                        indexingReport={indexingReport}
                                        showReportModal={showReportModal}
                                        setShowReportModal={setShowReportModal}
                                        handleIndexingReport={handleIndexingReport}
                                    />
                                )}
                            </div>
                        </TabPanel>

                        {/* User Import TabPanel */}
                        <TabPanel>
                            <UserImportPanel />
                        </TabPanel>
                    </Tabs>
                </div>
            </section>


            {/* Removed orphaned NewArticleForm - NewsManagement handles its own article forms now */}
            {showConsultationForm && (
                <ConsultationForm
                    consultation={selectedConsultation}
                    onSubmit={handleSubmitConsultation}
                    onClose={() => setShowConsultationForm(false)}
                    repositoryItems={repositoryItems}
                    workingGroups={Array.isArray(workingGroups) ? workingGroups : []}
                    onUploadDocument={handleYearChange}
                />
            )}
            {showPageProperties && selectedPageProperties && (
                <PagePropertiesModal
                    page={selectedPageProperties}
                    onClose={() => setShowPageProperties(false)}
                    onSave={handlePagePropertiesSave}
                />
            )}
            {showReportModal && indexingReport && (
                <Modal
                    isOpen={true}
                    onRequestClose={() => setShowReportModal(false)}
                    contentLabel="Indexing Report"
                    ariaHideApp={false}
                    style={{
                        overlay: {
                            zIndex: 99998,
                            backgroundColor: 'rgba(0,0,0,0.5)'
                        },
                        content: {
                            maxWidth: '600px',
                            margin: 'auto',
                            borderRadius: '10px',
                            padding: '24px',
                            boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
                            zIndex: 99999
                        }
                    }}
                >
                    <h2>Indexing Report</h2>
                    <p><strong>Successes:</strong> {indexingReport.successCount}</p>
                    <p><strong>Errors:</strong> {indexingReport.errorCount}</p>
                    {indexingReport.successes.length > 0 && (
                        <div style={{ marginBottom: '16px' }}>
                            <h4>Successfully Indexed:</h4>
                            <ul>
                                {indexingReport.successes.map((title, idx) => (
                                    <li key={idx}>{title}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {indexingReport.errors.length > 0 && (
                        <div style={{ color: 'red' }}>
                            <h4>Errors:</h4>
                            <ul>
                                {indexingReport.errors.map((err, idx) => (
                                    <li key={idx}><strong>{err.title}:</strong> {err.message}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <button onClick={() => setShowReportModal(false)} style={{ marginTop: '16px', padding: '8px 16px', borderRadius: '4px', background: '#007bff', color: 'white', border: 'none' }}>Close</button>
                </Modal>
            )}
            {showSurveyModal && (
                <Modal
                    isOpen={true}
                    onRequestClose={() => setShowSurveyModal(false)}
                    contentLabel="Survey Management"
                    ariaHideApp={false}
                    style={{
                        overlay: {
                            zIndex: 99998,
                            backgroundColor: 'rgba(0,0,0,0.5)'
                        },
                        content: {
                            maxWidth: '95vw',
                            maxHeight: '90vh',
                            margin: 'auto',
                            borderRadius: '10px',
                            padding: '24px',
                            boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
                            zIndex: 99999,
                            overflow: 'auto'
                        }
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <h2 style={{ margin: 0 }}>
                            <FontAwesomeIcon icon={faChartBar} style={{ marginRight: '10px' }} />
                            Survey Management
                        </h2>
                        <button 
                            onClick={() => setShowSurveyModal(false)}
                            style={{ 
                                background: 'none', 
                                border: 'none', 
                                fontSize: '1.5rem', 
                                cursor: 'pointer',
                                color: '#6c757d'
                            }}
                        >
                            ×
                        </button>
                    </div>
                    <SurveysManagement />
                </Modal>
            )}
            {showDaireModal && (
                <Modal
                    isOpen={true}
                    onRequestClose={() => setShowDaireModal(false)}
                    contentLabel="Daire Management"
                    ariaHideApp={false}
                    style={{
                        overlay: {
                            zIndex: 99998,
                            backgroundColor: 'rgba(0,0,0,0.5)'
                        },
                        content: {
                            maxWidth: '95vw',
                            maxHeight: '90vh',
                            margin: 'auto',
                            borderRadius: '10px',
                            padding: '24px',
                            boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
                            zIndex: 99999,
                            overflow: 'auto'
                        }
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <h2 style={{ margin: 0 }}>
                            <FontAwesomeIcon icon={faRobot} style={{ marginRight: '10px' }} />
                            Daire Management
                        </h2>
                        <button 
                            onClick={() => setShowDaireModal(false)}
                            style={{ 
                                background: 'none', 
                                border: 'none', 
                                fontSize: '1.5rem', 
                                cursor: 'pointer',
                                color: '#6c757d'
                            }}
                        >
                            ×
                        </button>
                    </div>
                    <div className='daire-container'>
                        <Tabs selectedIndex={selectedDaireTab} onSelect={handleDaireTabSelect}>
                            <TabList>
                                <Tab>
                                    <FontAwesomeIcon icon={faChartLine} className="tab-icon" />
                                    Usage
                                </Tab>
                                {/* <Tab>
                                    <FontAwesomeIcon icon={faDatabase} className="tab-icon" />
                                    Indexes
                                </Tab> */}
                                <Tab>
                                    <FontAwesomeIcon icon={faGear} className="tab-icon" />
                                    Daire Management
                                </Tab>
                            </TabList>

                            <TabPanel>
                                <DaireUsage currentUser={currentUser} />
                            </TabPanel>

                            {/* <TabPanel>
                                <IndexedDocuments currentUser={currentUser} />
                            </TabPanel> */}

                            <TabPanel>
                                <DaireManage currentUser={currentUser} />
                            </TabPanel>
                        </Tabs>
                    </div>
                </Modal>
            )}
            {showIndexingModal && (
                <Modal
                    isOpen={true}
                    onRequestClose={() => setShowIndexingModal(false)}
                    contentLabel="Indexing Management"
                    ariaHideApp={false}
                    style={{
                        overlay: {
                            zIndex: 99998,
                            backgroundColor: 'rgba(0,0,0,0.5)'
                        },
                        content: {
                            maxWidth: '95vw',
                            maxHeight: '90vh',
                            margin: 'auto',
                            borderRadius: '10px',
                            padding: '0px',
                            boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
                            zIndex: 99999,
                            overflow: 'auto'
                        }
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0px', padding: '24px 24px 0px 24px' }}>
                        <h2 style={{ margin: 0 }}>
                            <FontAwesomeIcon icon={faDatabase} style={{ marginRight: '10px' }} />
                            Indexing Management
                        </h2>
                        <button 
                            onClick={() => setShowIndexingModal(false)}
                            style={{ 
                                background: 'none', 
                                border: 'none', 
                                fontSize: '1.5rem', 
                                cursor: 'pointer',
                                color: '#6c757d'
                            }}
                        >
                            ×
                        </button>
                    </div>
                    <IndexingManagement />
                </Modal>
            )}
            {showNotificationModal && (
                <Modal
                    isOpen={true}
                    onRequestClose={() => setShowNotificationModal(false)}
                    contentLabel="Notification Management"
                    ariaHideApp={false}
                    style={{
                        overlay: {
                            zIndex: 99998,
                            backgroundColor: 'rgba(0,0,0,0.5)'
                        },
                        content: {
                            maxWidth: '95vw',
                            maxHeight: '90vh',
                            margin: 'auto',
                            borderRadius: '10px',
                            padding: '0px',
                            boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
                            zIndex: 99999,
                            overflow: 'auto'
                        }
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0px', padding: '24px 24px 0px 24px' }}>
                        <h2 style={{ margin: 0 }}>
                            <FontAwesomeIcon icon={faBell} style={{ marginRight: '10px' }} />
                            Notification Management
                        </h2>
                        <button 
                            onClick={() => setShowNotificationModal(false)}
                            style={{ 
                                background: 'none', 
                                border: 'none', 
                                fontSize: '1.5rem', 
                                cursor: 'pointer',
                                color: '#6c757d'
                            }}
                        >
                            ×
                        </button>
                    </div>
                    <NotificationManagement currentUser={currentUser} />
                </Modal>
            )}
        </div>
    );
}

Home.propTypes = {
    currentUser: PropTypes.object,
    isInitialized: PropTypes.bool
};

export default Home;